import React from 'react';

interface Props {
  color?: string;
  size?: number;
}

/**
 * FAQ・ヘルプ用アイコン（吹き出し）
 * HTMLデザインから抽出
 */
const HelpIcon: React.FC<Props> = ({ color = '#898989', size = 24 }) => (
  <svg
    viewBox="0 0 12 10.48"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M2.58,0h6.86c.7,0,1.34.29,1.81.75.46.47.75,1.11.75,1.83v3.84c0,.72-.29,1.36-.75,1.83-.47.46-1.11.75-1.81.75H2.58c-.7,0-1.36-.29-1.81-.75-.47-.47-.77-1.11-.77-1.83v-3.84c0-.72.29-1.36.77-1.83s1.11-.75,1.81-.75h0Z"
    />
    <rect
      fill={color}
      x="4.95"
      y="7.95"
      width="2.09"
      height="2.09"
      transform="translate(-4.61 6.88) rotate(-45)"
    />
  </svg>
);

export default HelpIcon;
